import { formatNameForDisplay } from 'lib/text-display'
import { DateTime } from 'luxon'

export const parseStudents = (students, sessions) => {
  return students.map(student => {
    const nextSession = findUpcomingSession(student.id, sessions)
    return {
      id: student.id,
      firstName: student.firstName,
      lastName: student.lastName,
      fullName: formatNameForDisplay(
        `${student.firstName} ${student.lastName}`,
      ),
      hasAccount: student.hasAccount,
      isMinor: student.isMinor,
      upcomingSession: nextSession,
      representatives: student.representatives,
      insights: student.insights,
    }
  })
}

export const findUpcomingSession = (studentId, sessions) => {
  const upcoming = sessions.currentUser.schedule.find(
    session =>
      session.enrollments[0]?.student.id === studentId &&
      session.isCanceled === false,
  )

  if (upcoming) {
    const sessionDate = formatUpcomingSessionDate(
      upcoming.startDateTime,
      upcoming.timezone,
    )

    return {
      humanizedStartDateTime: sessionDate.humanizedStartDateTime,
      sessionMonth: sessionDate.month,
      sessionDay: sessionDate.day,
      sessionTime: sessionDate.time,
      ...upcoming,
    }
  } else {
    return {
      __typename: null,
      humanizedStartDateTime: null,
      sessionMonth: null,
      sessionDay: null,
      sessionTime: null,
      title: null,
      startDateTime: null,
    }
  }
}

export const generateStudentListCsvData = students => {
  return students?.map(student => {
    return {
      'First Name': student.firstName,
      'Last Name': student.lastName,
      'Adult/Junior': student.isMinor ? 'Junior' : 'Adult',
      Phone: student.representatives[0]?.contact.phone || '',
      Email: student.representatives[0]?.contact.email || '',
    }
  })
}

const formatUpcomingSessionDate = (startDateTime, timezone) => {
  const start = DateTime.fromISO(startDateTime).setZone(timezone)
  if (!start.isValid) {
    return {
      month: null,
      day: null,
      time: null,
      humanizedStartDateTime: null,
    }
  }

  return {
    month: start.toFormat('LLL').toUpperCase(),
    day: start.toFormat('d'),
    time: start.toFormat('h:mm a'),
    humanizedStartDateTime: formatDate(startDateTime, timezone),
  }
}

const formatDate = (startDateTime, timezone) => {
  const start = DateTime.fromISO(startDateTime).setZone(timezone)
  if (!start.isValid) return null

  const now = DateTime.now().setZone(timezone)
  let datePart
  if (now.hasSame(start, 'day')) {
    datePart = 'Today'
  } else if (now.plus({ days: 1 }).hasSame(start, 'day')) {
    datePart = 'Tomorrow'
  } else {
    datePart = start.toFormat('ccc, LLL d')
  }

  return `${datePart} · ${start.toFormat('h:mm a')}`
}
